const textIndent = {
  name: "text-indent",
  path: "/text-indent",
  title: "Text Indent",
  description: "Utilities for controlling the indentation of the first line in a block of text.",
  value: {
    "text-indent": {
      "indent-<number>": "calc(var(--spacing) * <number>)",
      "-indent-<number>": "calc(var(--spacing) * -<number>)",
      "indent-px": "1px",
      "-indent-px": "-1px",
      "indent-[<value>]": "<value>"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="indent-4">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="-indent-4">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="indent-px">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="-indent-px">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
<p class="indent-[2em]">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">indent-4</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">-indent-4</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">indent-px</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">-indent-px</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">indent-[2em]</code> to control the indentation of the first line of text.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">indent-4</small>
          <p class="indent-4">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">-indent-4</small>
          <p class="-indent-4">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">indent-px</small>
          <p class="indent-px">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">-indent-px</small>
          <p class="-indent-px">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">indent-[2em]</small>
          <p class="indent-[2em]">The quick brown fox jumps over the lazy dog. The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
  ]
};

export default textIndent;
<div className="indent-4 -indent-4 indent-px -indent-px indent-[2em] sr-only"></div> 